import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageContainer = styled.div<{ $navBarHeight: number }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 32px;
  box-sizing: border-box;
  /* Pin to the viewport (minus the top nav bar and the routing container's details-view bottom
     margin) so only the document body scrolls internally — the header and panel stay put.
     The shell uses min-height:100vh + flex-grow, so a percentage height never resolves here. */
  height: calc(100vh - ${({ $navBarHeight }) => $navBarHeight}px - 20px);
  overflow: hidden;

  /* On narrow screens (mobile WebView) stack into a single column and let the page scroll —
     the fixed-width side panel would otherwise squeeze the document to a few pixels wide. */
  @media (max-width: 768px) {
    height: auto;
    overflow: visible;
    padding: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
`;

export const CrumbRow = styled.nav`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const CrumbLink = styled(Link)`
  color: ${({ theme }) => theme.palette.text.secondary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const CrumbSeparator = styled.span`
  color: ${({ theme }) => theme.palette.text.disabled};
`;

export const DocTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const MetaStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const MetaDot = styled.span`
  color: ${({ theme }) => theme.palette.text.disabled};
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  flex: 1;
  min-height: 0;
`;

export const PanelColumn = styled.div`
  align-self: start;
  position: sticky;
  top: 0;
`;

// Mobile (embedded) single-column stack: intro card, document, then the actions card.
export const MobileStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-height: 0;
`;

// Loading skeleton primitives

export const SkeletonBlock = styled.div<{ $height: string; $width?: string }>`
  height: ${({ $height }) => $height};
  width: ${({ $width }) => $width ?? '100%'};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.grey[200]};
`;
